import { displayErrorToast } from "@lya-protect/lya-protect-form-library/dist/UI";

export function validateAndHandleFile(
  file: File | undefined,
  acceptedTypes: string[],
  onSuccess: (file: File) => void
): boolean {
  if (!file) return false;

  if (!acceptedTypes.includes(file.type)) {
    displayErrorToast(
      `Seuls les fichiers de type ${acceptedTypes.join(", ")} sont acceptés`
    );
    return false;
  }

  onSuccess(file);
  return true;
}
